<template>
  <section class="feed-img" v-if="items.length">
    <div v-if="items.length === 1" class="img-con-wide">
      <img class="img_1" :src="thembnail(items[0].imageUrl)" alt="img">
    </div>
    <div v-else-if="items.length <= 3 && items.length > 1" class="img-con-wide">
      <img 
        v-for="(img, index) in items" :key="index" 
        :class="getImgClass(items.length, index)" 
        :src="thembnail(img.imageUrl)" 
        alt="img"
      >
    </div>
    <div v-else-if="items.length == 4" class="img-con">
      <img 
        v-for="(img, index) in items" :key="index" 
        :class="getImgClass(items.length, index)" 
        :src="thembnail(img.imageUrl)" 
        alt="img"
      >
    </div>
    <div v-else class="img-con-wide">
      <img 
        v-for="(img, index) in items" :key="index" 
        :class="getImgClass(items.length, index)" 
        :src="thembnail(img.imageUrl)" 
        alt="img"
      >
    </div>
  </section>
</template>
<script>
export default {
  name: 'FeedImgItem',
  props: {
    // 传入的img需仅为 Image 类型
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getImgClass(length, index) {
      if(length == 2) {
        switch(index) {
          case 0: return 'img_more top-left-radius bottom-left-radius'
          case 1: return 'img_more top-right-radius bottom-right-radius'
          default : return 'img_more'
        }
      } else if(length == 3) {
        switch(index) {
          case 0: return 'img_more top-left-radius bottom-left-radius'
          case 2: return 'img_more top-right-radius bottom-right-radius'
          default : return 'img_more'
        }
      } else if(length == 4) {
        switch(index) {
          case 0: return 'img_special top-left-radius'
          case 1: return 'img_special top-right-radius'
          case 2: return 'img_special bottom-left-radius'
          case 3: return 'img_special bottom-right-radius'
          default : return 'img_special'
        }
      } else if(length == 5) {
        switch(index) {
          case 0: return 'img_more top-left-radius'
          case 2: return 'img_more top-right-radius'
          case 3: return 'img_more bottom-left-radius'
          default : return 'img_more'
        }
      } else if(length == 6) {
        switch(index) {
          case 0: return 'img_more top-left-radius'
          case 2: return 'img_more top-right-radius'
          case 3: return 'img_more bottom-left-radius'
          case 5: return 'img_more bottom-right-radius'
          default : return 'img_more'
        }
      } else if(length == 7 || length == 8) {
        switch(index) {
          case 0: return 'img_more top-left-radius'
          case 2: return 'img_more top-right-radius'
          case 6: return 'img_more bottom-left-radius'
          default : return 'img_more'
        }
      } else if(length == 9) {
        switch(index) {
          case 0: return 'img_more top-left-radius'
          case 2: return 'img_more top-right-radius'
          case 6: return 'img_more bottom-left-radius'
          case 8: return 'img_more bottom-right-radius'
          default : return 'img_more'
        }
      }
    },
    thembnail(url) {
      return `${url}?imageView&thumbnail=400y400`
    }
  }
}
</script>
<style lang="scss" scoped>
.img-con-wide {
  width: 100%;
}
.img-con {
  width: 5rem;
}
.feed-img {
  .img_1 {
    max-height: 3rem;
    max-width: 4.48rem;
    border-radius: .24rem;
  }
  .img_more {
    width: 2.22rem;
    height: 2.22rem;
    margin-right: .08rem;
    &:nth-child(3n) {
      margin: 0;
    }
  }
  .img_special {
    width: 2.22rem;
    height: 2.22rem;
    margin-right: .08rem;
    &:nth-child(2n) {
      margin: 0;
    }
  }
  .top-left-radius {
    border-top-left-radius: .24rem;
  }
  .top-right-radius {
    border-top-right-radius: .24rem;
  }
  .bottom-right-radius {
    border-bottom-right-radius: .24rem;
  }
  .bottom-left-radius {
    border-bottom-left-radius: .24rem;
  }
}
</style>
